import { render } from "./ModalStatus.vue?vue&type=template&id=fac47446"
import script from "./ModalStatus.vue?vue&type=script&lang=js"
export * from "./ModalStatus.vue?vue&type=script&lang=js"
script.render = render

export default script